import { jsx as s } from "react/jsx-runtime";
import { QueryClientProvider as x } from "./contact-channels47.js";
import { isTreatmentEnabled as f } from "./contact-channels57.js";
import { WHATSAPP_CONFIG as m } from "./contact-channels58.js";
import { getAvailableCountries as _ } from "./contact-channels59.js";
import { checkCallMeSpamProtection as b } from "./contact-channels60.js";
import { getChannelsData as E } from "./contact-channels61.js";
import { getEmergencyData as F } from "./contact-channels36.js";
import { useState as C, useEffect as v, createContext as T, useContext as l } from "react";
import { CHANNELS_CONFIG as y } from "./contact-channels44.js";
import { queryClient as i } from "./contact-channels62.js";
import { RecaptchaProvider as L } from "./contact-channels63.js";
import { TranslationsProvider as N } from "./contact-channels38.js";
const O = (r) => {
  var o;
  const e = y[r.toLowerCase()];
  return ((o = e == null ? void 0 : e.contactUsComponents) == null ? void 0 : o.includes("call_me_v2")) ?? !1;
}, h = T({
  locale: "en-us",
  auth: void 0,
  origin: "DefaultOrigin",
  tenant: "vistaprint",
  proadvantageType: "",
  isProadvantage: !1,
  loadingProAdvantage: !0,
  whatsAppConfig: m
}), z = () => {
  const r = l(h);
  if (!r)
    throw new Error("useContactChannelsContext must be used within a ContactChannelsProvider");
  return r;
}, B = ({
  children: r,
  locale: e,
  origin: o,
  auth: g,
  useRecaptcha: P,
  prefetchQueries: u,
  callMeConfig: n,
  whatsAppConfig: w,
  tenant: t = "vistaprint"
}) => {
  const [p, d] = C(""), [q, c] = C(!0);
  return v(() => {
    var a;
    c(!0), (a = y[e.toLowerCase()]) != null && a.proadvantageProgram && typeof window < "u" && window.document && (f("proadvantage_basic_care") ? d("basic") : f("proadvantage_premium_care") && d("premium")), c(!1);
  }, [e]), v(() => {
    u && (i.prefetchQuery({ queryKey: ["channels-data"], queryFn: () => E(e) }), i.prefetchQuery({ queryKey: ["emergency"], queryFn: () => F(t, e) }), O(e) && (i.prefetchQuery({
      queryKey: ["c2c-spam"],
      queryFn: () => b(n == null ? void 0 : n.allowVPNs)
    }), i.prefetchQuery({
      queryKey: ["c2c-countries", e, t, "Regular", []],
      queryFn: () => _(t, e, "Regular")
    })));
  }, [e, t, u, n]), /* @__PURE__ */ s(x, { client: i, children: /* @__PURE__ */ s(L, { locale: e, origin: o, useRecaptcha: P, children: /* @__PURE__ */ s(
    h.Provider,
    {
      value: {
        locale: e,
        auth: g,
        origin: o,
        tenant: t,
        proadvantageType: p,
        isProadvantage: !!p,
        loadingProAdvantage: q,
        callMeConfig: n,
        whatsAppConfig: {
          ...m,
          ...Object.fromEntries(
            Object.entries(w || {}).map(([a, A]) => [
              a,
              { ...m[a], ...A }
            ])
          )
        }
      },
      children: /* @__PURE__ */ s(N, { tenant: t, locale: e, children: r })
    }
  ) }) });
};
export {
  B as ContactChannelsProvider,
  z as useContactChannelsContext
};
//# sourceMappingURL=contact-channels14.js.map
